import {createApp, markRaw} from "vue";
import { createPinia } from "pinia";
import "./config/firebase";
import App from "./App.vue";
import router from "./router";

import "./assets/base.css";

import { Quasar, Notify } from "quasar";

// ---- QUASAR ----
// Import icon libraries
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/material-symbols-outlined/material-symbols-outlined.css";

// Import Quasar css
import "quasar/src/css/index.sass";
// ---- /QUASAR ----

// @ts-ignore
import VueClipboard from 'vue3-clipboard'

const app = createApp(App);
const pinia = createPinia();

app.use(pinia.use(({ store }) => {
  // important! dont add a $router here
  store.router = markRaw(router)
}));
app.use(VueClipboard, { autoSetContainer: true })
app.use(Quasar, {
  plugins: { Notify }, // import Quasar plugins and add here
});
app.use(router);

app.mount("#app");
